var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextInput } from '@/components/form/text-input.component';
import { UserDetailsFormConsent } from '@/components/user-details/user-details-form-consent.component';
import { InputAdornment } from '@mui/material';
import { regex } from '@/constants/regex.constant';
import { getBirthYearValidationMessage } from '@/components/form/helpers/get-birth-year-validation-message.helper';
import { HealthAndMemberDiscountsSelect } from '@/components/user-details/health-and-member-discount.component';
import { isValidMobileNumber } from '@/components/user-details/helpers/is-valid-mobile-number';
export function StyledTextInput(props) {
    return (_jsx(TextInput, __assign({ sx: {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#3364d9',
                borderWidth: '2px',
            },
            '&:hover:not(.Mui-focused)': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3364d9',
                    borderWidth: '1px',
                },
            },
        } }, props)));
}
export function UserDetailsForm(_a) {
    var form = _a.form;
    var control = form.control;
    return (_jsxs("div", __assign({ className: "flex flex-col gap-3 md:px-4" }, { children: [_jsxs("div", __assign({ className: "grid md:grid-cols-2 w-full gap-x-2 gap-y-3" }, { children: [_jsx(StyledTextInput, { controlProps: {
                            name: 'first-name',
                            control: control,
                            rules: {
                                required: 'First Name is required',
                                minLength: {
                                    value: 2,
                                    message: 'First Name must be at least 2 characters',
                                },
                                maxLength: {
                                    value: 26,
                                    message: 'First Name must be less than 26 characters',
                                },
                                pattern: {
                                    value: regex.personName,
                                    message: 'First name should be valid (e.g. John)',
                                },
                            },
                        }, label: "First name*" }), _jsx(StyledTextInput, { controlProps: {
                            name: 'last-name',
                            control: control,
                            rules: {
                                required: 'Last Name is required',
                                minLength: {
                                    value: 2,
                                    message: 'Last Name must be at least 2 characters',
                                },
                                maxLength: {
                                    value: 26,
                                    message: 'Last Name must be less than 26 characters',
                                },
                                pattern: {
                                    value: regex.personName,
                                    message: 'Last name should be valid (e.g. Doe)',
                                },
                            },
                        }, label: "Last name*" }), _jsx(StyledTextInput, { controlProps: {
                            name: 'email',
                            control: control,
                            rules: {
                                required: 'Email is required',
                                pattern: {
                                    value: regex.email,
                                    message: 'Invalid email address (e.g. johndoe@email.com)',
                                },
                            },
                        }, label: "Email*" }), _jsx(StyledTextInput, { inputProps: {
                            pattern: '[0-9]{10}',
                            maxLength: 10,
                        }, InputProps: {
                            startAdornment: (_jsx(InputAdornment, __assign({ position: "start" }, { children: "+1" }))),
                        }, controlProps: {
                            name: 'contact-number',
                            control: control,
                            rules: {
                                required: 'Contact number is required',
                                validate: function (value) {
                                    if (value.length !== 10) {
                                        return 'Contact number must be 10 digits';
                                    }
                                    if (!isValidMobileNumber("+1".concat(value))) {
                                        return 'Enter a valid contact number';
                                    }
                                    return true;
                                },
                            },
                        }, type: "tel", label: "Contact number*" }), _jsx(StyledTextInput, { controlProps: {
                            name: 'birth-year',
                            control: control,
                            rules: {
                                required: 'Birth year is required',
                                pattern: {
                                    value: regex.year,
                                    message: 'YYYY e.g. 2000',
                                },
                                validate: function (value) {
                                    return getBirthYearValidationMessage(value);
                                },
                            },
                        }, inputProps: {
                            maxLength: 4,
                        }, label: "Birth year*" }), _jsx(HealthAndMemberDiscountsSelect, { form: form })] })), _jsx(UserDetailsFormConsent, {})] })));
}
